"use client";

import Accordion from "@/components/Accordion";
import { useTranslationDetector } from "@/hooks/useTranslationDetector";
import { sendGTMEvent } from "@next/third-parties/google";

const FaqSection = ({ items = [] }) => {
  const t = useTranslationDetector();

  return (
    <Accordion
      onItemToggle={(id, item) => {
        sendGTMEvent({
          event: "custom_event",
          event_category: "custom_event",
          event_action: "faq_selected",
          faq_question: item.title,
        });
      }}
      items={items.map((item) => ({
        id: item.Id,
        title: item.Name,
        content: item.Description,
      }))}
    />
  );
};

export default FaqSection;
